__turbopack_context__.v({
  "actions": "TemplatePreSelectModal-module__INkHKW__actions",
  "btnGhost": "TemplatePreSelectModal-module__INkHKW__btnGhost",
  "btnPrimary": "TemplatePreSelectModal-module__INkHKW__btnPrimary",
  "btnSec": "TemplatePreSelectModal-module__INkHKW__btnSec",
  "card": "TemplatePreSelectModal-module__INkHKW__card",
  "close": "TemplatePreSelectModal-module__INkHKW__close",
  "grid": "TemplatePreSelectModal-module__INkHKW__grid",
  "head": "TemplatePreSelectModal-module__INkHKW__head",
  "hint": "TemplatePreSelectModal-module__INkHKW__hint",
  "hintHi": "TemplatePreSelectModal-module__INkHKW__hintHi",
  "item": "TemplatePreSelectModal-module__INkHKW__item",
  "itemLabel": "TemplatePreSelectModal-module__INkHKW__itemLabel",
  "itemOn": "TemplatePreSelectModal-module__INkHKW__itemOn",
  "overlay": "TemplatePreSelectModal-module__INkHKW__overlay",
  "thumb": "TemplatePreSelectModal-module__INkHKW__thumb",
  "title": "TemplatePreSelectModal-module__INkHKW__title",
});
